var _g, _g2, _g3, _rect, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogoCross = function SvgLogoCross(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 152,
    viewBox: "0 0 153 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.000366211,
    width: 152,
    height: 152,
    rx: 75.9998,
    fill: "#FF3535"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 11.9999,
    width: 128,
    height: 128,
    rx: 63.9998,
    fill: "#FF3535"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.4992,
    y: 24.0004,
    width: 104,
    height: 103.999,
    rx: 51.9996,
    fill: "#FF3535"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 36,
    width: 80,
    height: 80.0007,
    rx: 40,
    fill: "#FF3535"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2115_1479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5004 66.4293L66.5004 86.4293",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5004 86.4293L66.5004 66.4293",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2115_1479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5556,
    height: 35.5555,
    fill: "white",
    transform: "translate(58.7222 58.6515)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoCross.877554f5d4b85692d88f1a702b240fc6.svg";